import { useState } from 'react';

/**
 * One-shot secret reveal control (copied from apps/client-ui per Phase 10
 * brief — duplicated rather than promoted to a shared package because the
 * surface is small and avoids cross-package churn).
 */
export function MaskedSecret({
  value,
  label,
}: {
  value: string;
  label?: string;
}) {
  const [revealed, setRevealed] = useState(false);
  return (
    <div className="flex items-center gap-2">
      {label ? <span className="text-sm text-slate-600">{label}</span> : null}
      {revealed ? (
        <code
          data-testid="masked-secret-value"
          className="rounded bg-slate-100 px-2 py-1 font-mono text-xs"
        >
          {value}
        </code>
      ) : (
        <span
          data-testid="masked-secret-placeholder"
          aria-hidden
          className="font-mono text-xs tracking-widest text-slate-400"
        >
          ••••••••••••
        </span>
      )}
      <button
        type="button"
        className="btn"
        onClick={() => setRevealed((v) => !v)}
      >
        {revealed ? 'Hide' : 'Reveal'}
      </button>
      {revealed ? (
        <button
          type="button"
          className="btn"
          onClick={() => void navigator.clipboard?.writeText(value)}
        >
          Copy
        </button>
      ) : null}
    </div>
  );
}
